import { createSvgIcon } from '@mui/material';

export const ErrorIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
    <path
      fill="currentColor"
      d="M11.778 20c-.49 0-.908-.174-1.256-.522A1.712 1.712 0 0 1 10 18.222c0-.489.174-.907.522-1.255a1.712 1.712 0 0 1 1.256-.523c.489 0 .907.175 1.255.523.349.348.523.766.523 1.255 0 .49-.174.908-.523 1.256a1.712 1.712 0 0 1-1.255.522ZM10 14.667V4h3.556v10.667H10Z"
    />
  </svg>,
  'ErrorIcon',
);
